import { GraphQLQueryClass } from "@bsm/component";
import { TInvoice, TUserStudentFamily } from "@bsm/graphql";

export class UserStudentFamilyQuery implements GraphQLQueryClass<TUserStudentFamily, TResponse>
{
    public queryKey: string = "App.Bsm.Invoice.UserStudentFamilyQuery";

    public gql: string = `
    query($id:Float!){
        userStudentFamily(filter:{id:$id}){
            id
            designation
            fatherName
            motherName
            paymentPeriod
            paymentCurrency
            paymentType
            comments
            emails { to email}
            members {
                type student {
                    id isEnrolled user { id fullName }
                }
            }
            currencies { id descriptorKey translationKey }
            createdAt
            userCreator { id fullName }
            isEditable
            isDeletable
        }
    }
 `;
    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TUserStudentFamily {
        return data.userStudentFamily;
    }
}

export type TResponse = {
    userStudentFamily: TUserStudentFamily;
};
